document.addEventListener("DOMContentLoaded", () => {
  const testimonials = document.querySelectorAll(".testimonials li");
  let current = 0;

  // Set initial visibility
  gsap.set(testimonials[current], { opacity: 1, y: 0 });

  function showNextTestimonial() {
    const prev = current;
    current = (current + 1) % testimonials.length;

    // Animate out current testimonial
    gsap.to(testimonials[prev], {
      opacity: 0,
      y: -30,
      duration: 0.6,
      ease: "power2.inOut",
      onComplete: () => {
        gsap.set(testimonials[prev], { y: 30 });
      },
    });

    // Animate in next testimonial
    gsap.fromTo(
      testimonials[current],
      { opacity: 0, y: 30 },
      { opacity: 1, y: 0, duration: 0.8, ease: "power3.out" }
    );
  }

  // Auto cycle every 4 seconds
  setInterval(showNextTestimonial, 4000);
});
